/**
 * Sidebar Layout component terms
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const sidebarLayout = {
	component: {
		label: "component:sidebarLayout#label",
		description: "component:sidebarLayout#description"
	}
};
